export const roles = {
  Owner: {
    canManage: [
      "Admin",
      "Top-Leader",
      "Leader",
      "Co-Leader",
      "Observer",
      "Chat-Admin",
      "Finals-Executer",
    ],
  },
  Admin: {
    canManage: [
      "Top-Leader",
      "Leader",
      "Co-Leader",
      "Observer",
      "Chat-Admin",
      "Finals-Executer",
      "Customer-Service",
    ],
  },
  "Top-Leader": {
    canManage: ["Leader", "Co-Leader"],
  },
  Leader: {
    canManage: ["Co-Leader"],
  },
};
